export default "__VITE_ASSET__CrDEeV4Z__"